/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { WardDto } from '../models/ward-dto';
import { wardsGetWards } from '../fn/wards/wards-get-wards';
import { WardsGetWards$Params } from '../fn/wards/wards-get-wards';

@Injectable({ providedIn: 'root' })
export class WardsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `wardsGetWards()` */
  static readonly WardsGetWardsPath = '/api/wards';

  /**
   * Get all wards.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wardsGetWards()` instead.
   *
   * This method doesn't expect any request body.
   */
  wardsGetWards$Response(params?: WardsGetWards$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WardDto>>> {
    const obs = wardsGetWards(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all wards.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wardsGetWards$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wardsGetWards(params?: WardsGetWards$Params, context?: HttpContext): Observable<Array<WardDto>> {
    const resp = this.wardsGetWards$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WardDto>>): Array<WardDto> => r.body)
    );
  }

}
